import type { NodeType } from "@velizhanin-dev/bot-scenario"
import type { ScenarioDraft } from "@/entities/bot-builder"
import { AddBlockMenu } from "@/features/edit-scenario-draft"
import { cn } from "@/shared/lib/utils"
import { BlockSearch } from "./block-search"
import { FLOATING_PANEL_CLASS } from "./canvas-toolbar"

interface ListToolbarProps {
	draft: ScenarioDraft
	addBlockHint: string
	onAddBlock: (type: Exclude<NodeType, "start">) => void
	onPickNode: (nodeId: string) => void
}

/** Панель под списком блоков: добавить и найти: масштаб списку не нужен. */
export function ListToolbar({ draft, addBlockHint, onAddBlock, onPickNode }: ListToolbarProps) {
	return (
		<div className="pointer-events-none absolute inset-x-0 bottom-3 z-10 flex justify-center px-3">
			<div className={cn(FLOATING_PANEL_CLASS, "pointer-events-auto flex items-center gap-1 p-1.5")}>
				<AddBlockMenu onPick={onAddBlock} hint={addBlockHint} />
				<BlockSearch draft={draft} onPick={onPickNode} />
			</div>
		</div>
	)
}
